module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.7ac4e80b.webp";